import { useContext, useEffect } from "react";
import "./App.css";
import Login from "./pages/loginPage/Login";
import BlackbaudCallback from "./components/BlackbaudCallback";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import LoginPage from "./pages/homePage/LoginPage";
import MissingPage from "./pages/missingPage/MissingPage";
import UnauthorizedPage from "./pages/unauthorizedPage/UnauthorizedPage";
import Layout from "./components/layout/Layout";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { getUserLogin } from "./reduxSlices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useJwt } from "react-jwt";
import { VF_ADMIN_ROLE_ID } from "./constants/constant";
import { AuthContext } from "react-oauth2-code-pkce";
import HomePage from "./pages/homePage/HomePage";
import { Service } from "./services/service";
import { blackbaudConfig } from "./helpers/helper";

const service = new Service();

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { login } = useContext(AuthContext);
    const token = localStorage.getItem("bb_access_token");
  const { decodedToken, isExpired } = useJwt(token);
  const email = localStorage.getItem("email") || "";
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);
  const isUserActive = currentUser?.isActive;
  const isEnvActive =
    currentUser?.environments && currentUser?.environments[0]?.isActive;
  const urlParams = new URLSearchParams(location.search);
  console.log("urlParams", urlParams, location);
  console.log("isExpired", isExpired, decodedToken);

    console.log("CurrENV-------------------------", process.env.NODE_ENV);

  useEffect(() => {
    console.log("Redirected to app");
    const fetchUserLogin = async () => {
      try {
          if (email) {
              //check the time of the token
              if (token && isTokenExpired()) {
                  if (window.confirm("Session expired. Please log in again to continue.")) {
                      //window.location.reload();
                      ["bb_access_token", "user_access_token", "user_data", "email",
                       "ROCP_loginInProgress", "ROCP_token", "ROCP_tokenExpire",
                       "ROCP_refreshToken", "ROCP_refreshTokenExpire", "ROCP_idToken"]
                        .forEach((key) => localStorage.removeItem(key));
                      window.location.href = "/login";
                  }
              }
              else {
                   if (token && isNearlyExpired()) {
                          await checkUserLogin(email);
                   }
                  const obj = { email: email };
                  let response = await dispatch(getUserLogin(obj));
                  let userData = response?.payload?.data;
                  if (!userData) {
                      await checkUserLogin(email);
                      response = await dispatch(getUserLogin(obj));
                      userData = response?.payload?.data;
                  }
                  const userRole = userData?.roles?.map((item) => item.roleId);
                  const isActive =
                      userData?.environments && userData?.environments[0]?.isActive;
                  if (!isActive && userData && !userRole?.includes(VF_ADMIN_ROLE_ID)) {
                      navigate("/accessdenied");
                  }
              }
        }
        else {
          if (location.pathname != "/auth/callback" && location.pathname != "/login" && location.pathname != "/" && location.pathname != "/home") {
            localStorage.removeItem("bb_access_token");
            navigate("/login");
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/login");
      }
    };
    if (
      location.pathname !== "/" &&
      location.pathname !== "/home" &&
      location.pathname !== "/auth/callback"
    ) {
      fetchUserLogin();
    }
  }, [location.pathname]);

  const RedirectHandler = () => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("https://visualiseapp.com/")) {
      window.location.replace("https://visualisereporting.com");
    } else {
      return <Navigate to="/login" replace />;
    }
    return null;
  };

    const isNearlyExpired = () => {
        if (!decodedToken?.exp) return false;
        const now = Math.floor(Date.now() / 1000); // seconds
        const timeLeft = decodedToken.exp - now;
        return timeLeft > 0 && timeLeft <= 900; // 15 min
    };

    const isTokenExpired = () => {
        if (!decodedToken?.exp) return false; // token not yet decoded — assume valid
        const now = Math.floor(Date.now() / 1000); // current time in seconds
        return decodedToken.exp <= now;
    };

  useEffect(() => {
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  const checkUserLogin = async (userEmail) => {
    let url = `/api/User/CheckUserLogin?email=` + userEmail;
    //const user_token = localStorage.getItem("bb_access_token");
    try {
      let res = await service.newPostApi(url, {}, null);
      let response = res.data;
      if (response.success == false) {
        localStorage.removeItem("bb_access_token");
        navigate("/login");
      }
      else {
        //get user tokens and then call login api
        const bbUserData = response.data;
        localStorage.setItem("email", bbUserData?.emailId);
          localStorage.setItem("bb_access_token", bbUserData?.token);
      }
    } catch (err) {
      console.log(err);
      localStorage.removeItem("bb_access_token");
      navigate("/login");
    }
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<RedirectHandler />} />
        <Route path="/admin" element={<Login />} />
        {/* <Route
          path="/home"
          element={
            token ? <Navigate to={"/dashboard"} replace /> : <HomePage />
          }
        /> */}
        <Route
          path="/home"
          element={
            token && !isExpired ? <Navigate to={"/dashboard"} replace /> : <LoginPage />
          }
        />
        <Route
          path="/login"
          element={
            token && !isExpired ? <Navigate to={"/dashboard"} replace /> : <LoginPage />
          }
        />
        <Route path="auth/callback" element={<BlackbaudCallback />} />
        <Route path="/*" element={<Layout />} />
        <Route
          path="unauthorized"
          element={
            <UnauthorizedPage
              title={"Unauthorized"}
              message={"You do not have access to the requested page."}
            />
          }
        />
        <Route
          path="accessdenied"
          element={
            <UnauthorizedPage
              title={"Access Denied"}
              message={
                "You do not have access to the requested page, because your organization or environment or user is not active, you will need to contact your administrator."
              }
            />
          }
        />
        <Route path="*" element={<MissingPage />} />
      </Routes>
      <ToastContainer style={{ fontFamily: "Montserrat", fontSize: "14px" }} />
    </>
  );
}

export default App;
